<template>
  <div class="view-tasklists" style="background-color: #CCC;">
  <header>
    <div class="mobile-header fixed-top">
      <div class="float-left">
        <img class="w-60 mt1" src="@/assets/MM-logo.png" alt="MentorMentee" @click="logoTapRedirect">

      </div>
      <div class="float-right">
        &nbsp;
      </div>
    </div>
  </header>

    <div class="wrapper" style="width: 70% !important; margin: 0 auto;">

        <div class="content-wrapper">
          <div class="container-wrapper center">
            <div>
              <div class="col-12 p-0 float-left">
                <h3 class="d-inline heading" style="padding-top: 2px;">Assessment Report</h3>
              </div>
              <div style="clear: both"></div>
              
            </div>
            <div class="heading-seperator" style="margin-top: 2px;"></div>
            <div class="margin-bottom-10"></div>
            <div v-show="loading" class="loading_show">
              <div class="spinner-border text-danger"></div>
            </div>
            <flash-message autoHide variant="success"></flash-message>
            <iframe id="pdf-frame" style="display: none;""></iframe>

            <div class="preview-section">

              <div class="print-section" style="min-height: 350px;  color: #002F42;">
                <link href="https://use.typekit.net/wmq5ujp.css"  rel='stylesheet' type='text/css'>
                <link href="https://fonts.googleapis.com/css?family=Roboto+Condensed&display=swap" rel="stylesheet">
                <div style="width: 70%; float: left; padding: 0;  color: #002F42; ">
                  <div style="font-size: 20px; font-weight: bold; text-transform: ucwords;font-family: 'bebas-neue',sans-serif;color: #00ACEE;">{{ user_first_name }}</div>
                  <div style="font-size: 15px; font-weight: bold; text-decoration: underline;font-family: 'bebas-neue',sans-serif;color: #00ACEE;">{{ assessment_title }}</div>
                  <div style="font-size: 15px;font-family: 'proxima-nova',sans-serif;"> {{ completion_date }} (CST)</div>
                  <div style="font-size: 15px;font-family: 'proxima-nova',sans-serif;">at {{ account_name }}</div>

                </div>
                <div style="width: 30%; float: right; text-align: right; " v-if="pdf_file_name">
                  <div class="circle"  style="float: right;"><i class="fa fa-share-alt cursor-pointer" aria-hidden="true" v-on:click="shareButtonModal(), verrors.clear()"></i></div>
                  <div style="float: right; margin-right: 10px;"><i class="fa fa-print cursor-pointer" aria-hidden="true" @click="printFunc()" style="font-size: 36px; padding-top: 0px; "></i></div>
                  <div style="float: right; margin-right: 10px; margin-top: 2px;"><i class="fa fa-download cursor-pointer" aria-hidden="true" @click="downloadFunc()" style="font-size: 36px; padding-top: 0px; "></i></div>
                  <div style="clear: both;"></div>
                </div>
                
                <div style="clear: both; margin-bottom: 10px;"></div>
                <div style="width: 90%; margin: 0 auto; padding: 0; font-family: 'bebas-neue', sans-serif; color: #002F42;">
                  <div style="width: 100%; padding: 20px 20px 20px 10px; margin-top: 20px; margin-bottom: 20px; border: 2px solid #BFBFBF; border-radius: 10px;">
                    <div style="font-size: 21px; text-decoration: underline; text-align: center; font-weight: bold;">Mentoring Categories</div>
                    <div style="width: 100%" id="myChartDiv">
                      <canvas id="myChart" width="400" :height="height" ></canvas>
                    </div>
                  </div>
                  <div style="width: 100%; padding: 0; text-align: center; font-style: italic; font-size: 13px; font-family: 'Calibri', sans-serif;" v-if="(overall_output_title != '' && overall_output_text != '')">
                    See Below for Overall Report
                  </div>
                  <div style="width: 100%; padding: 0; text-align: left; font-family: 'Calibri', sans-serif;">

                    <div style="font-size: 17px; margin-top: 30px;"  v-if="assessment_details != ''">
                      <span v-html="assessment_details"></span>
                    </div>
                    <div style="border-bottom: 1px solid #00ACEE;
  margin: 0px; margin-top: 20px; margin-bottom: 0px;"></div>
                  </div>
                  <div style="width: 100%; padding: 0; font-family: 'Calibri', sans-serif;" v-if="(overall_output_title != '' && overall_output_text != '')">
                    <div style="font-size: 21px; font-weight: bold; text-align: center; margin-top: 20px; margin-bottom: 2px;" >
                      {{ overall_output_title }}
                    </div>
                    <div style="text-align: center; font-style: italic; font-size: 13px; margin-bottom: 20px;">
                    {{ user_score + '/' + total_score }}
                    </div>
                    <div style="font-size: 17px; margin-top: 30px;" >
                      <span v-html="overall_output_text"></span>
                    </div>
                  </div>
                  <div style="width: 100%; padding: 0; text-align: center; font-style: italic; font-size: 13px; margin-top: 30px; font-family: 'Calibri', sans-serif;" v-if="(output_ranges.length > 0)">
                    See Below for Detailed Sections Report
                    <div style="border-bottom: 1px solid #00ACEE;
  margin: 0px; margin-top: 20px; margin-bottom: 0px;"></div>
                  </div>
                  <div style="width: 100%; padding: 0;font-family: 'Calibri', sans-serif;">
                    <div style="font-size: 17px; margin-top: 20px;" v-for="(range, index) in output_ranges" :key="index">
                      <span v-html="range"></span>
                    </div>
                  </div>
                  <div style="margin-top: 40px; margin-bottom: 20px;font-family: 'Calibri', sans-serif;" >
                    <div style="text-align: center; font-style: italic; font-size: 17px; ">For information on Mentor Mentee's assessments, use  the link below:</div>
                    <div style="font-size: 17px; text-align: center; "><a href="https://mentormentee.com/assessment-policy" target="_blank" style="color: #53C6F3; text-decoration: underline; cursor: pointer;">mentormentee.com/assessment-policy</a></div>
                  </div>

                </div>
              </div>
              <div style="clear: both; margin-bottom: 25px;"></div>


              
              <div style="clear: both; margin-bottom: 25px;"></div>

            
            </div>
          </div>
        </div>
    </div>
    <ShareReportModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <span v-if="loading" class="pull-right text-danger">
        Loading...
      </span>
      <div slot="header" class="sub-heading"><h3>Share Report</h3></div>
      <div slot="body">
        <div class="col-12 override-padding">
          <input v-model="share_email"
                name="share_email"
                placeholder="Enter Email..."
                class="col-lg-12 input-text form-control"
                style="line-height: 30px "
                v-validate="'required|email'"
                data-vv-as="Email address"
                maxlength="255" />
         <div v-show="verrors.has('share_email')" class="validate-warning-msg">{{ verrors.first('share_email') }}</div>
        </div>
        <div style="clear: both;" class="margin-bottom-10"></div>


        <div class="col-12 override-padding text-align-right">
          <button
              v-on:click="shareButtonSubmit()"
              class="btn btn-dard-grey col-lg-3"
              style="line-height: 30px; border-radius: 10px;"
              ><b>{{ submit_text }}</b></button>
        </div>

      </div>
      <div slot="footer" class="col-3 override-padding">

      </div>
    </ShareReportModal>

  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import GoBack from './shared/goback.vue';
import axios from 'axios';
import { store } from '../store/store';
import router from '../router/index.js';
import ShareReportModal from './admin/create-tasklist-modal.vue';
import VeeValidate from 'vee-validate';
import Chart from 'chart.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
        data() {
          return {
            assessmentId: '',
            assessmentAttemptId: '',
            masterAdmin: false,
            admin: false,
            assessment_title: '',
            section_scale: '',
            loading: false,
            admin: false,
            user_first_name: '',
            assessment_title: '',
            completion_date: '',
            account_name: '',
            output_ranges: [],
            assessment_details: '',
            overall_output_title: '',
            overall_output_text: '',
            total_score: 0,
            user_score: 0,
            height: 300,
            barValues: [],
            barLabels: [],
            barBgColor: [],
            share_email: '',
            isModalVisible: false,
            submit_text: 'Submit',
            pdf_file_name: '',
            apiUrl: '',
            token: '',
          }
        },

        components: {
          GoBack,
          ShareReportModal,
        },
        methods: {
            closeModal() {
              this.$emit('close');
            },
            logoTapRedirect: function() {
              router.push('/');
            },
            shareButtonSubmit: function() {
              this.$validator.validateAll().then((result) => {
                if ((this.verrors.items.length === 0)) {
                  this.submit_text = 'Please wait...';
                  axios('/custom/mentor-user-assessment-report-email/' + this.assessmentAttemptId + '/' + this.token,
                     {
                       method: 'POST',
                       data:
                        {
                          email: this.share_email,
                        },
                     }
                   )
                  .then((resp) => {
                    this.share_email = '';
                    this.submit_text = 'Submit';
                    this.isModalVisible = false;
                    this.$emit('close');

                   })
                  .catch(error => {

                  });
                }
              });

            },
            shareButtonModal() {
              this.isModalVisible = true;
            },

            downloadFunc: function() {


              var url = this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name;
   
              //Create XMLHTTP Request.
              var req = new XMLHttpRequest();
              req.open("GET", url, true);
              req.responseType = "blob";
              req.onload = function () {
                  //Convert the Byte Data to BLOB object.
                  var blob = new Blob([req.response], { type: "application/octetstream" });
   
                  //Check the Browser type and download the File.
                  var isIE = false || !!document.documentMode;
                  if (isIE) {
                      window.navigator.msSaveBlob(blob, fileName);
                  } else {
                      var url = window.URL || window.webkitURL;
                      var link = url.createObjectURL(blob);
                      var a = document.createElement("a");
                      a.setAttribute("download", "assessment_report.pdf");
                      a.setAttribute("href", link);
                      document.body.appendChild(a);
                      a.click();
                      document.body.removeChild(a);
                  }
              };
              req.send();
              return false;
            },
            printFunc: function() {

              fetch(this.apiUrl + '/custom/pdf-view/' + this.pdf_file_name).then(function(response) {
                  return response.blob();
              }).then(function(myBlob) {
                  var objectURL = URL.createObjectURL(myBlob);
                  document.querySelector('#pdf-frame').src = '';
                  document.querySelector('#pdf-frame').src = objectURL;
                  objectURL = URL.revokeObjectURL(myBlob);
              }).then(
                  function() {
                      window.setTimeout(function() {
                          document.querySelector('#pdf-frame').contentWindow.print();
                      }, 1000)
                  });
                return false;
            },
            onHomePageRedirect: function() {
              var url = '';
              if(store.state.roles.indexOf('ROLE_ADMIN') > -1) {
                url = "/company-admin-dashboard";
              }
              else if(store.state.roles.indexOf('ROLE_MENTOR') > -1) {
                url = "/mentor-dashboard";
              }
              else if(store.state.roles.indexOf('ROLE_MENTEE') > -1) {
                url = "/mentee-dashboard";
              }
              else if(store.state.roles.indexOf('ROLE_APPRENTICE') > -1) {
                url = "/apprentice-dashboard";
              }
              else if(store.state.roles.indexOf('ROLE_ENTERPRISE_ADMIN') > -1) {
                url = "/enterprise-admin-dashboard";
              }
              router.push(url);
            },
        },
        created() {
          this.assessmentAttemptId = this.$route.params.assessmentAttemptId;
          this.token = this.$route.params.token;
          this.apiUrl = process.env.API_ENDPOINT;
          axios.get('/custom/user-assessment-report/' + this.assessmentAttemptId, {
          })
          .then(resp =>  {
            this.assessment_title = resp.data.assessment_title;
            this.completion_date = resp.data.completion_date;
            this.account_name = resp.data.account_name;
            this.user_first_name = resp.data.user_first_name;
            this.output_ranges = resp.data.output_ranges;
            this.assessment_details = resp.data.assessment_details;
            this.overall_output_title = resp.data.overall_output_ranges.title;
            this.overall_output_text = resp.data.overall_output_ranges.text;
            this.total_score = resp.data.total_score;
            this.user_score = resp.data.user_total_score;
            this.barLabels = resp.data.graph_title;
            this.barValues = resp.data.graph_value;
            this.pdf_file_name = resp.data.pdf_file_name;
            for(var j=0; j<this.barLabels.length; j++) {
              this.barBgColor.push('#2EACEE');
            }
            if(this.barLabels.length > 10) {
              this.height = parseInt(this.barLabels.length * 50);  
            }
            else if(this.barLabels.length > 5) {
              this.height = parseInt(this.barLabels.length * 60);
            }
            else {
              this.height = parseInt(this.barLabels.length * 70);
            }
            
            if(this.barLabels.length > 0) {
              setTimeout(() => {
              var ctx = document.getElementById('myChart');
              var barData = {
                datasets: [{
                    data: this.barValues,
                    backgroundColor: this.barBgColor,
                    borderColor: this.barBgColor,
                    labels: this.barLabels,
                    borderWidth: 1,
                    borderRadius: 10,
                    borderSkipped: false,
                }],

                labels: this.barLabels,
              };

              var myChart = new Chart(ctx, {
                  type: 'horizontalBar',
                  data: barData,
                  options: {
                      indexAxis: 'y',
                      elements: {
                        bar: {
                          borderWidth: 1,
                        }
                      },
                      title: {
                          display: false,
                      },
                      layout: {
                        padding: {
                          left: 0,
                          right: 60,
                          top: 15,
                          bottom: 0
                        }
                      },
                      responsive: true,
                      maintainAspectRatio: false,
                      legend: {
                        display: false
                      },
                      events: [],
                      animation: {
                          duration: 1,
                          onComplete: function() {
                              var chartInstance = this.chart,
                                  ctx = chartInstance.ctx;

                              ctx.font = Chart.helpers.fontString('15', Chart.defaults.global.defaultFontStyle, "'bebas-neue', sans-serif");
                              ctx.textAlign = 'start';
                              ctx.textBaseline = 'center';

                              this.data.datasets.forEach(function(dataset, i) {
                                  var meta = chartInstance.controller.getDatasetMeta(i);
                                  meta.data.forEach(function(bar, index) {
                                      if (dataset.labels[index]) {
                                          var data = dataset.labels[index];
                                          var data1 = dataset.data[index] + '%';
                                          ctx.fillText(data, 10, parseInt(bar._model.y - 12));
                                          ctx.fillText(data1, bar._model.x + 10, parseInt(bar._model.y + 5));
                                      }
                                      dataset.backgroundColor[index] = '2EACEE';
                                  });
                              });
                          }
                      },
                      scales: {
                          xAxes: [{
                              ticks: {
                                  beginAtZero: true,
                                  max: 100,
                                  min: 0,
                                  stepSize: 25,
                                  callback: function(value,   index, values) {
                                    return value + '%';
                                  },
                              },
                              gridLines: {
                                drawOnChartArea:false,
                              }
                          }],
                          yAxes: [{
                            barThickness: 7,
                            categoryPercentage: 1.0,
                            display: false,
                            gridLines: {
                              display:false,
                              drawBorder: true,
                            },
                            stacked: true,
                          }],
                      }
                  }
              });
              }, 3000);
            }
          })
          .catch(function(error) {
            console.log(error);
          });
        },

}

</script>

<style scoped>
.preview-section {
  width: 75%;
  margin: 0 auto;
  background-color: #FFF;
  border-radius: 10px;
  padding: 15px 25px;
  color: #797979;
}
.circle {
  background-color: #2EACEE;  
  border-radius: 50%;
  height: 36px;
  width: 36px;
  text-align: center;
}
.circle i {
  color: #FFF;  
  font-size: 24px;
  text-align: center;
  padding-top: 5px;
  padding-right: 2px;
}
.print-section {
  font-family: 'Roboto Condensed', sans-serif;
}
br {
  display: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mentor_assessment_report.vue